// src/pages/QuanLyHocSinh/QuanLyHocSinhDesktop.js
import React, { useState } from "react";
import { formatDate } from "../../utils";

const STATUS_STYLE = {
  dangHoc: 'text-green-700 bg-green-50 border-green-200',
  nghiHoc: 'text-red-700 bg-red-50 border-red-200',
  chuyenLop: 'text-blue-700 bg-blue-50 border-blue-200'
};

const QuanLyHocSinhDesktop = ({ filtered, getTenLop, getTenGiaoHo, getTenNganh, onView, onEdit, onDelete, canEdit, canDelete }) => {
  const [page, setPage] = useState(1);
  const PER_PAGE = 10;
  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  if (filtered.length === 0) {
    return <div className="bg-surface rounded-xl border border-outline-variant text-center py-16 text-on-surface-variant"><span className="material-symbols-outlined text-[64px]">person_off</span><p className="text-body-lg">Không tìm thấy</p></div>;
  }

  return (
    <div className="bg-surface-container-lowest rounded-xl shadow-sm border border-outline-variant overflow-hidden">
      <table className="w-full text-left">
        <thead><tr className="bg-surface-container-low border-b border-outline-variant"><th className="px-4 py-3 text-label-caps">Học sinh</th><th className="px-4 py-3 text-label-caps">Ngày sinh</th><th className="px-4 py-3 text-label-caps">Lớp</th><th className="px-4 py-3 text-label-caps">Giáo họ</th><th className="px-4 py-3 text-label-caps">Trạng thái</th><th className="px-4 py-3 text-label-caps text-right">Thao tác</th></tr></thead>
        <tbody className="divide-y divide-outline-variant">
          {paginated.map(hs => (
            <tr key={hs.id} className="hover:bg-surface-container-low cursor-pointer transition-colors" onClick={() => onView(hs)}>
              <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-container text-on-primary-container flex items-center justify-center text-sm font-bold">{hs.hoTen?.charAt(0)}</div>
                  <div>
                    <p className="text-body-md font-semibold">{hs.tenThanh && <span className="text-primary">{hs.tenThanh} </span>}{hs.hoTen}</p>
                    {(hs.sdtBo || hs.sdtMe) && <p className="text-caption text-on-surface-variant">📞 {hs.sdtBo || hs.sdtMe}</p>}
                  </div>
                </div>
              </td>
              <td className="px-4 py-3 text-body-md">{hs.ngaySinh ? formatDate(hs.ngaySinh) : '—'} · {hs.gioiTinh}</td>
              <td className="px-4 py-3"><span className="px-2 py-0.5 rounded-full text-label-caps bg-blue-50 text-blue-700">{getTenLop(hs.lopHienTaiId)}</span></td>
              <td className="px-4 py-3 text-body-md">{hs.giaoHoId ? getTenGiaoHo(hs.giaoHoId) : '—'}</td>
              <td className="px-4 py-3"><span className={`px-2 py-1 rounded-full text-label-caps border ${STATUS_STYLE[hs.trangThai] || ''}`}>{hs.trangThai === 'dangHoc' ? 'Đang học' : hs.trangThai === 'nghiHoc' ? 'Nghỉ học' : 'Chuyển lớp'}</span></td>
              <td className="px-4 py-3 text-right" onClick={e => e.stopPropagation()}>
                <div className="flex justify-end gap-1">
                  <button onClick={() => onView(hs)} className="w-8 h-8 rounded-full hover:bg-surface-variant flex items-center justify-center"><span className="material-symbols-outlined text-[18px]">visibility</span></button>
                  {canEdit && <button onClick={() => onEdit(hs)} className="w-8 h-8 rounded-full hover:bg-surface-variant flex items-center justify-center"><span className="material-symbols-outlined text-[18px]">edit</span></button>}
                  {canDelete && <button onClick={() => onDelete(hs)} className="w-8 h-8 rounded-full hover:bg-error-container flex items-center justify-center text-error"><span className="material-symbols-outlined text-[18px]">delete</span></button>}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div className="px-4 py-3 border-t border-outline-variant flex justify-between bg-surface-container-low">
          <p className="text-caption">Hiển thị {(page-1)*PER_PAGE+1}–{Math.min(page*PER_PAGE, filtered.length)} / {filtered.length}</p>
          <div className="flex gap-1">
            <button disabled={page===1} onClick={() => setPage(p=>p-1)} className="w-8 h-8 rounded-lg border disabled:opacity-30">◀</button>
            {Array.from({length: totalPages}, (_,i)=>i+1).filter(p=>p===1||p===totalPages||Math.abs(p-page)<=1).map((p,i,a)=>(<React.Fragment key={p}>{i>0&&a[i-1]!==p-1&&<span>...</span>}<button onClick={()=>setPage(p)} className={`w-8 h-8 rounded-lg text-caption font-bold ${page===p?'bg-primary text-on-primary':''}`}>{p}</button></React.Fragment>))}
            <button disabled={page===totalPages} onClick={() => setPage(p=>p+1)} className="w-8 h-8 rounded-lg border disabled:opacity-30">▶</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuanLyHocSinhDesktop;